import React from "react";

import "./Button.css";

const Button = (props) => {
  return (
    <button
      id={props.id}
      className={`button button--${props.variant || "default"}`}
      type={props.type}
      onClick={props.onClick}
      disabled={props.disabled}
      style={props.style}
    >
      {props.children}
    </button>
  );
};

export default Button;
